"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkmark = function Checkmark(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M5.477 8.495L4 9.845l3.948 4.322 6.596-8.983L12.932 4 7.78 11.017z" })
  );
};

exports.default = Checkmark;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Checkmark.js
// module id = 685
// module chunks = 0